import { defineStore } from 'pinia'

import state from './state'
import getters from './getters'
import actions from './actions'

const useRoutinesStore = defineStore('routines', {
  state,
  getters,
  actions
})

export default useRoutinesStore
